module.exports = __webpack_public_path__ + "img/footer.48142d3c.jpg";